export default __webpack_public_path__ + "static/media/privacy-policy-banner.c8edaa88.jpg";